import { useContext } from 'react'
import {
  IQuestionFailedResource,
  IQuizResource,
  IWorkplaceQuizState,
} from '../../models/WorkplaceQuiz'
import { onKeyPressHandler } from '../../utilities/commonFunctions'
import Conditional from '../common/Conditional'
import WorkplaceQuizContext from './context/WorkplaceQuizContext'
import WorkplaceQuizSummaryButtons from './WorkplaceQuizSummaryButtons'
import WorkplaceResultsResourceItemLink from './WorkplaceResultsResourceItemLink'
const govCMSUrl = process.env.REACT_APP_GOVCMS_HOME

export interface IWorkplaceResultsResourceItemsProps {
  startQuiz: (id: number) => void
}
const WorkplaceResultsResourceItems = (
  props: IWorkplaceResultsResourceItemsProps
) => {
  const context = useContext(WorkplaceQuizContext)
  const navigate = (item: IWorkplaceQuizState) => {
    if (item.quizId === null || item.quizId === undefined || item.quizId <= 0) {
      return
    }
    props.startQuiz(item.quizId)
  }
  return (
    <div className="resourceArea">
      <ul className="moduleList">
        {context.currentState?.quizStatus.map(
          (item: IWorkplaceQuizState, index) => {
            return (
              <li key={index} className="moduleItem">
                <h3>{item.title}</h3>
                <Conditional if={!item.completed}>
                  <a
                    className="startText"
                    onClick={() => navigate(item)}
                    role="button"
                    tabIndex={0}
                    onKeyPress={onKeyPressHandler}
                  >
                    START
                  </a>
                </Conditional>
                <Conditional if={item.completed}>
                  <span className="startText scoreText">
                    <span className="big">
                      {item.correctAnswered.length}/{item.totalQuestions}
                    </span>{' '}
                    &nbsp; COMPLETED
                  </span>
                </Conditional>
                <Conditional if={item.completed}>
                  <div className="linksArea">
                    <div className="linkArea">
                      <ul>
                        {item.remainderResources.map(
                          (item: IQuizResource, index) => {
                            return (
                              <WorkplaceResultsResourceItemLink
                                key={index}
                                url={govCMSUrl + item.link}
                                content={item.content}
                              />
                            )
                          }
                        )}

                        {item.failedResources.map(
                          (item: IQuestionFailedResource, index) => {
                            return (
                              <WorkplaceResultsResourceItemLink
                                key={index}
                                url={govCMSUrl + item.resource?.link}
                                content={item.resource?.content}
                              />
                            )
                          }
                        )}
                      </ul>
                    </div>
                  </div>
                </Conditional>
              </li>
            )
          }
        )}
      </ul>
      <div className="moduleAfter">
        <h3>
          Don&apos;t forget to use the industry filters on our web pages to
          learn more about rights and obligations in your industry.
        </h3>
      </div>
      <WorkplaceQuizSummaryButtons startQuiz={props.startQuiz} />
    </div>
  )
}

export default WorkplaceResultsResourceItems
